import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { InformacionTramiteDefault } from '@app/shared';

@Injectable()
export class ProcedureDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Consulta todos los tramites
   *
   * @param {number} idForm
   * @returns {Observable<InformacionTramiteDefault[]>}
   * @memberof ProcedureDataService
   */
   loadProcedures(): Promise<InformacionTramiteDefault[]> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().
       get<InformacionTramiteDefault[]>(this.api.get('tramiteProcessCategory')).subscribe(
        tramit => {
          resolve(tramit);
        },
        err =>  {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/procedure/shared/procedure.data.service.ts